import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PLATFORM_NAME, SUPPORT_EMAIL } from '../config/brand';
import './FAQPage.css';

const FAQ_DATA = [
  {
    q: `What is ${PLATFORM_NAME}?`,
    a: `${PLATFORM_NAME} is an AI-powered coding assessment platform. Complete assigned timed tests and get detailed AI feedback on your submissions.`,
  },
  {
    q: 'Who can use the platform?',
    a: 'Students who have been assigned an assessment can create an account, verify their email, and take the test during the scheduled window.',
  },
  {
    q: 'How do I get started?',
    a: 'You can get started by:\n1. Creating a free account on CodeHub\n2. Verifying your email\n3. Opening your dashboard to see assigned assessments\n4. Starting a test during its scheduled window',
  },
  {
    q: 'How many free submissions do I get?',
    a: 'New users receive a free trial of AI-reviewed submissions (see current pricing on the landing page). After that, you can purchase credit packs or subscriptions.',
  },
  {
    q: 'What does the AI review include?',
    a: 'Each submission is scored on correctness, efficiency, code quality, readability, and security. You also receive actionable feedback to improve your solution.',
  },
  {
    q: 'Which programming languages are supported?',
    a: 'Python, JavaScript, TypeScript, Java, Kotlin, C++, C, C#, Go, and PHP.',
  },
  {
    q: 'How do credits work?',
    a: 'Each AI-reviewed submission uses one credit. You can buy credit packs via Razorpay from the Credits page, or use your monthly free tier allowance if available.',
  },
  {
    q: 'What payment methods are accepted?',
    a: 'Payments can be made using UPI, debit cards, credit cards, net banking, and other supported online payment methods through our secure Razorpay gateway.',
  },
  {
    q: 'Can I get mentor support?',
    a: 'Yes. Use the Support button in the navbar to contact our mentor support team if you need help with the platform.',
  },
  {
    q: 'How can I contact support?',
    a: `Use the in-app Support form or email us at ${SUPPORT_EMAIL}.`,
  },
];

const FAQItem = ({ item, isOpen, onToggle }) => (
  <div className={`faq-item ${isOpen ? 'faq-item--open' : ''}`}>
    <button className="faq-question" onClick={onToggle}>
      <span>{item.q}</span>
      <svg className={`faq-chevron ${isOpen ? 'faq-chevron--open' : ''}`} width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
    {isOpen && (
      <div className="faq-answer">
        {item.a.split('\n').map((line, i) => (
          <p key={i}>{line}</p>
        ))}
      </div>
    )}
  </div>
);

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="faq-page">
      <div className="faq-container">

        <Link to="/" className="faq-back-link">← Back to Home</Link>

        <div className="faq-header">
          <span className="faq-eyebrow">Support</span>
          <h1 className="faq-title">Frequently Asked Questions</h1>
          <p className="faq-subtitle">
            Everything you need to know about Batos IT CodeHub assessments.
            Can't find what you're looking for? <a href={`mailto:${SUPPORT_EMAIL}`}>Contact us</a>.
          </p>
        </div>

        <div className="faq-list">
          {FAQ_DATA.map((item, i) => (
            <FAQItem
              key={i}
              item={item}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? null : i)}
            />
          ))}
        </div>

        <div className="faq-cta">
          <h3>Still have questions?</h3>
          <p>Our support team is here to help you.</p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="faq-cta-btn">
            ✉️ Email Us
          </a>
        </div>

      </div>
    </div>
  );
};

export default FAQPage;
